import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class ModuleTask extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M12.4,2.3H3.6L3.3,2.6v10.9l0.3,0.3h8.8l0.3-0.3V2.6L12.4,2.3z M5.9,2.9h4.1v0.9H5.9V2.9z M12.1,13.1H3.9
          V2.9h1.4v1.2l0.3,0.3h4.7l0.3-0.3V2.9h1.4V13.1z"
          />
          <polygon points="7.8,10 5.9,8.8 5.6,9.3 7.8,10.6 8.2,10.5 10.5,6.2 10,5.9  " />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ModuleTask.js